import React from 'react'
import Nav from '../common/Nav'

import { host } from '../script/variables';
import { useState } from 'react';
import { useEffect } from 'react';
import BottomNav from '../BottomNav';
import '../style/BrandStory.css';

/* ----------------------------- Line icons ----------------------------- */
/* Defined outside the component so they are not re-created on every render */
const svgProps = {
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round',
  'aria-hidden': true,
};

const NavMark = () => (
  <svg {...svgProps} stroke="#FFFFFF" strokeWidth={2}>
    <polygon points="3 11 22 2 13 21 11 13 3 11" />
  </svg>
);
const QrIcon = () => (
  <svg {...svgProps}>
    <rect x="3" y="3" width="7" height="7" rx="1.2" />
    <rect x="14" y="3" width="7" height="7" rx="1.2" />
    <rect x="3" y="14" width="7" height="7" rx="1.2" />
    <rect x="5.6" y="5.6" width="1.8" height="1.8" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="16.6" y="5.6" width="1.8" height="1.8" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="5.6" y="16.6" width="1.8" height="1.8" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="14.5" y="14.5" width="2" height="2" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="19" y="14.5" width="1.6" height="1.6" rx="0.3" fill="currentColor" stroke="none" />
    <rect x="14.5" y="19" width="1.6" height="1.6" rx="0.3" fill="currentColor" stroke="none" />
    <rect x="18.6" y="18.6" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
  </svg>
);
const ZapIcon = () => (
  <svg {...svgProps}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
);
const FlameIcon = () => (
  <svg {...svgProps}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);
const ChatIcon = () => (
  <svg {...svgProps}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
);
const UsersIcon = () => (
  <svg {...svgProps}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const PinIcon = () => (
  <svg {...svgProps}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const ChartIcon = () => (
  <svg {...svgProps}>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);
const HomeIcon = () => (
  <svg {...svgProps}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

/* ----------------------------- Page content ----------------------------- */
const guestPains = [
  'Waiting for a menu',
  'Waiting for someone to take the order',
  'No idea where the order is',
  'Repeating the same details, again and again',
  'Leaving without sharing honest feedback',
];
const ownerPains = [
  'Never knowing why a customer didn’t return',
  'Never knowing which dishes people truly love',
  'Never knowing which tables drive real revenue',
  'Hours lost to operations instead of hospitality',
];
const ecosystem = [
  { icon: <QrIcon />, title: 'Effortless ordering', desc: 'Guests order in seconds — no queue, no friction.' },
  { icon: <ZapIcon />, title: 'Automated operations', desc: 'Restaurants run on systems, not manual effort.' },
  { icon: <FlameIcon />, title: 'Efficient kitchens', desc: 'Orders reach the line clearly and instantly.' },
  { icon: <ChatIcon />, title: 'Real feedback', desc: 'Honest input that actually drives improvement.' },
  { icon: <UsersIcon />, title: 'Shared food moments', desc: 'Great dishes discovered and shared together.' },
  { icon: <PinIcon />, title: 'Local discovery', desc: 'Neighbourhood restaurants, easy to find.' },
  { icon: <ChartIcon />, title: 'Decisions from data', desc: 'Every call backed by data, not guesswork.' },
];

const BrandStory = () => {

  const [isLogin, setIsLogin] = useState(false);
  const [vegMode, setVegMode] = useState(false);

  const checkLogin = async () => {
    try {
      const res = await fetch(`${host}/user/vlogin`, {
        method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') },
      });
      setIsLogin(res.ok);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { checkLogin() }, []);

  // Scroll-triggered reveal (graceful fallback if unsupported / reduced motion)
  useEffect(() => {
    const els = document.querySelectorAll('.bs-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('bs-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('bs-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <Nav setIsLogin={setIsLogin} isLogin={isLogin} vegMode={vegMode} />

      <main className="bs-page">

        {/* ============================ HERO ============================ */}
        <section className="bs-section bs-hero">
          <div className="bs-container bs-hero-inner">
            <span className="bs-eyebrow bs-eyebrow--light bs-reveal" style={{ transitionDelay: '0ms' }}>
              The RestroPilots Story
            </span>
            <h1 className="bs-h1 bs-reveal" style={{ transitionDelay: '110ms' }}>
              Restaurants don’t fail because<br className="bs-br" /> they make bad food.
            </h1>
            <p className="bs-lead bs-lead--light bs-reveal" style={{ transitionDelay: '220ms' }}>
              They lose customers because the experience around that food
              is <span className="bs-accent">broken</span>.
            </p>
          </div>
        </section>

        {/* ========================= THE WAIT ========================= */}
        <section className="bs-section bs-light">
          <div className="bs-container">
            <span className="bs-eyebrow bs-reveal">The everyday reality</span>
            <h2 className="bs-h2 bs-reveal">
              Every day, millions walk in excited to eat.<br className="bs-br" /> Instead,
              they <span className="bs-accent">wait</span>.
            </h2>

            <div className="bs-split bs-reveal">
              <article className="bs-pcard">
                <header className="bs-pcard-head">
                  <span className="bs-pcard-ic"><UsersIcon /></span>
                  <h3 className="bs-pcard-title">For the guest</h3>
                </header>
                <ul className="bs-list">
                  {guestPains.map((p) => <li key={p}>{p}</li>)}
                </ul>
              </article>

              <article className="bs-pcard">
                <header className="bs-pcard-head">
                  <span className="bs-pcard-ic"><HomeIcon /></span>
                  <h3 className="bs-pcard-title">For the owner</h3>
                </header>
                <ul className="bs-list">
                  {ownerPains.map((p) => <li key={p}>{p}</li>)}
                </ul>
              </article>
            </div>
          </div>
        </section>

        {/* ========================== THE GAP ========================== */}
        <section className="bs-section bs-dark bs-glow-center">
          <div className="bs-container bs-center">
            <span className="bs-eyebrow bs-eyebrow--light bs-reveal">The gap</span>
            <p className="bs-lead bs-lead--light bs-reveal">
              The biggest chains buy their way out of this — with expensive technology.
            </p>
            <div className="bs-stat bs-reveal">95%<span className="bs-stat-plus">+</span></div>
            <p className="bs-stat-cap bs-reveal">
              of restaurants — especially across Tier-2 &amp; Tier-3 cities — still run on
              disconnected tools, manual processes, and guesswork.
            </p>
            <h2 className="bs-h2 bs-h2--light bs-reveal">
              That’s the gap <span className="bs-accent">RestroPilots</span> exists to close.
            </h2>
          </div>
        </section>

        {/* ========================= THE MISSION ========================= */}
        <section className="bs-section bs-light">
          <div className="bs-container bs-center">
            <span className="bs-eyebrow bs-reveal">Our belief</span>
            <h2 className="bs-h2 bs-reveal">
              Every restaurant deserves the same technology as
              the <span className="bs-accent">biggest brands</span> — whatever its size,
              wherever it is.
            </h2>

            <div className="bs-trio bs-reveal">
              {[['Serve', ' better'], ['Operate', ' smarter'], ['Grow', ' faster']].map(([a, b], i) => (
                <div className="bs-pill" key={a} style={{ transitionDelay: `${i * 70}ms` }}>
                  <span className="bs-accent">{a}</span>{b}
                </div>
              ))}
            </div>
            <p className="bs-note bs-reveal">That’s the whole mission.</p>
          </div>
        </section>

        {/* ========================= THE PLATFORM ========================= */}
        <section className="bs-section bs-gray">
          <div className="bs-container">
            <span className="bs-eyebrow bs-reveal">The platform</span>
            <h2 className="bs-h2 bs-reveal">It starts with QR ordering. It doesn’t end there.</h2>
            <p className="bs-lead bs-reveal">
              We’re building the <span className="bs-accent">operating system</span> for the
              next generation of restaurants.
            </p>

            <div className="bs-grid">
              {ecosystem.map((f, i) => (
                <article className="bs-card bs-reveal" key={f.title} style={{ transitionDelay: `${(i % 4) * 60}ms` }}>
                  <span className="bs-card-ic">{f.icon}</span>
                  <h3 className="bs-card-title">{f.title}</h3>
                  <p className="bs-card-desc">{f.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ========================== THE VISION ========================== */}
        <section className="bs-section bs-light">
          <div className="bs-container">
            <span className="bs-eyebrow bs-reveal">The vision</span>
            <h2 className="bs-h2 bs-reveal">This is bigger than software.</h2>
            <p className="bs-lead bs-reveal">
              We want to digitize the restaurant ecosystem of Tier-2 &amp; Tier-3 India — so a
              small local kitchen can deliver an experience as <span className="bs-accent">seamless</span> as
              the world’s biggest chains.
            </p>
            <blockquote className="bs-quote bs-reveal">
              When restaurants grow, local businesses grow.<br className="bs-br" />
              When experiences improve, communities grow <span className="bs-accent">stronger</span>.
            </blockquote>
          </div>
        </section>

        {/* ========================== CLOSING ========================== */}
        <section className="bs-section bs-dark bs-glow-soft bs-closing">
          <div className="bs-container bs-center">
            <h2 className="bs-final bs-reveal">
              RestroPilots isn’t building software.<br className="bs-br" />
              We’re building the <span className="bs-accent">infrastructure behind the
              future of hospitality</span>.
            </h2>
            <p className="bs-tagline bs-reveal">One restaurant at a time.</p>

            <div className="bs-lockup bs-reveal">
              {/* <span className="bs-badge"><NavMark /></span> */}
              <span className="bs-wordmark">RestroPilots</span>
            </div>
            <p className="bs-kicker bs-reveal">Streamline. &nbsp;Grow.</p>
          </div>
        </section>

      </main>

      <BottomNav />
    </>
  )
}

export default BrandStory